export enum EmployeeTerminationApprovalStatus {
  Yes = "Yes",
  No = "No",
  NA='NA'
}
